import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getCompanyPads,
  getAllCompanyPads,
  getCompanyPad,
  createCompanyPad,
  editCompanyPad,
  deleteCompanyPad,
} from "api/companyPadApi"

export const COMPANY_PAD_QUERY_KEY = "company-pads"

// -------------------- FETCH PAGINATED --------------------
export const useCompanyPads = (params = {}, enabled = true) => {
  return usePaginatedResource(
    COMPANY_PAD_QUERY_KEY,
    getCompanyPads,
    params,
    enabled
  )
}

// -------------------- FETCH ALL --------------------
export const useAllCompanyPads = (params = {}, enabled = true) => {
  return usePaginatedResource(
    [COMPANY_PAD_QUERY_KEY, "all"],
    getAllCompanyPads,
    { ...params, all: true },
    enabled
  )
}

// -------------------- FETCH SINGLE ITEM --------------------
export const useCompanyPad = (id, enabled = true) => {
  return useResourceItem(COMPANY_PAD_QUERY_KEY, getCompanyPad, id, enabled)
}

// -------------------- CREATE --------------------
export const useCreateCompanyPad = () => {
  return useCreateResource(createCompanyPad, COMPANY_PAD_QUERY_KEY)
}

// -------------------- EDIT --------------------
export const useEditCompanyPad = () => {
  return useEditResource(editCompanyPad, COMPANY_PAD_QUERY_KEY)
}

// -------------------- DELETE --------------------
export const useDeleteCompanyPad = () => {
  return useDeleteResource(deleteCompanyPad, COMPANY_PAD_QUERY_KEY)
}
